import React from 'react';
import MonacoIDEWithZustand from './MonacoIDEWithZustand'; // New Zustand implementation
import { ProjectFile, FileTreeNode, CanisterInfo, NPMPackageInfo } from '../types';
import { Project, PackageInfo } from '../UserCanister/candid/main.did';
import { Principal } from '@dfinity/principal';

// Extended props to include optimistic update handlers
interface MonacoIDEWrapperProps {
    project: Project;
    canisterId: string;
    onError: (error: string | null) => void;
    onSuccess: (message: string | null) => void;
    userCanisters: CanisterInfo[];
    onProjectUpdate?: () => Promise<void>;
    userPrincipal: Principal | null;
    useZustand?: boolean; // Flag to switch between implementations
    // 🆕 NEW: Optimistic canister operation handlers
    onAddCanisterToProject?: (
        projectId: string,
        canisterId: string,
        onSuccess?: (message: string) => void,
        onError?: (message: string) => void
    ) => Promise<boolean>;
    onRemoveCanisterFromProject?: (
        projectId: string,
        canisterId: Principal,
        onSuccess?: (message: string) => void,
        onError?: (message: string) => void
    ) => Promise<boolean>;
}

/**
 * Wrapper component that conditionally renders either the original MonacoIDE
 * or the new Zustand-based MonacoIDEWithZustand implementation.
 * Now includes optimistic update handlers for instant canister operations.
 */
const MonacoIDEWrapper: React.FC<MonacoIDEWrapperProps> = (props) => {
    const {
        useZustand = false,
        onAddCanisterToProject,
        onRemoveCanisterFromProject,
        ...restProps
    } = props;

    // Pass through all props including the new optimistic handlers
    return (
        <MonacoIDEWithZustand
            {...restProps}
            onAddCanisterToProject={onAddCanisterToProject}
            onRemoveCanisterFromProject={onRemoveCanisterFromProject}
        />
    );
};

export default MonacoIDEWrapper;